import React from "react";
import striptags from "striptags";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";

export const GamePostContent = ({ data }) => {
  if (!data.postBy.game_type) {
    return null;
  }

  return (
    <div>
      <div className="section-title" itemProp="description">Game Instructions</div>
      <p>{striptags(data.postBy.mabp_instructions)}</p>
      <div className="section-title">GAME DESCRIPTION</div>
      <p>{striptags(data.postBy.description)}</p>
      <div>
        <SimpleReactLightbox>
          <SRLWrapper>
            {data.postBy.mabp_screen1_url && (
              <>
                <div className="section-title">GAME SCREENSHOTS</div>
                <div className="group w-32 h-32 relative cursor-pointer mr-4 mb-4 inline-flex">
                  <span className="opacity-0 group-hover:opacity-100 transition-opacity absolute left-0 bottom-0 w-full p-1 bg-block text-center font-bold">
                    Zoom
                  </span>
                  <img
                    className="group-hover:opacity-100 object-cover h-full w-full"
                    src={data.postBy.mabp_screen1_url}
                    alt={data.postBy.title}
                  />
                </div>
              </>
            )}
            {data.postBy.mabp_screen2_url && (
              <div className="group w-32 h-32 relative cursor-pointer mr-4 mb-4 inline-flex">
                <span className="opacity-0 group-hover:opacity-100 transition-opacity absolute left-0 bottom-0 w-full p-1 bg-block text-center font-bold">
                  Zoom
                </span>
                <img
                  className="group-hover:opacity-100 object-cover h-full w-full"
                  src={data.postBy.mabp_screen2_url}
                  alt={data.postBy.title}
                />
              </div>
            )}
            {data.postBy.mabp_screen3_url && (
              <div className="group w-32 h-32 relative cursor-pointer mr-4 mb-4 inline-flex">
                <span className="opacity-0 group-hover:opacity-100 transition-opacity absolute left-0 bottom-0 w-full p-1 bg-block text-center font-bold">
                  Zoom
                </span>
                <img
                  className="group-hover:opacity-100 object-cover h-full w-full"
                  src={data.postBy.mabp_screen3_url}
                  alt={data.postBy.title}
                />
              </div>
            )}
            {data.postBy.mabp_screen4_url && (
              <div className="group w-32 h-32 relative cursor-pointer mr-4 mb-4 inline-flex">
                <span className="opacity-0 group-hover:opacity-100 transition-opacity absolute left-0 bottom-0 w-full p-1 bg-block text-center font-bold">
                  Zoom
                </span>
                <img
                  className="group-hover:opacity-100 object-cover h-full w-full"
                  src={data.postBy.mabp_screen4_url}
                  alt={data.postBy.title}
                />
              </div>
            )}
          </SRLWrapper>
        </SimpleReactLightbox>
      </div>
    </div>
  );
};
